export const zIndexes = {
  base: 0, // 基本層
  header: 3, // 一般需要高一點層級的 header 區塊
  stickyHeader: 10, // 固定在上方的區塊需要高一點的層級
  modal: 100, // 模態視窗
  overlay: 200, // 遮罩層
  tooltip: 300, // 工具提示
  sheet: 100000, // sheet
  sheetAbovePageFooter: 1000001, // 高於頁面底部固定按鈕的 sheet（新增/修改地址等）
  dropdown: 100001, // 下拉選單（一般頁面）
  dropdownAboveSheet: 1000003, // 下拉選單（需高於 sheet，在 Sheet 內使用時選項才不會被遮住）
  top: 100002,
  toast: 1000003, // 訊息通知（需高於 sheet，以便在 sheet 內訂位失敗時仍能顯示）
  /** 高於所有 Sheet/Overlay，確保在 Sheet 內觸發的 toast 會顯示在最上層 */
  toastAboveSheet: 1000010,
};